import { useEffect, useState } from "react";
import { PortalColaboradorService } from "services/PortalColaboradorService";

const useObtenerAprobadorPrimerNivel = () => {
	const [aprobadorPrimerFlujo, setAprobadorPrimerFlujo] = useState(undefined);
	useEffect(() => {
		const cargarDatos = async () => {
			const aprobadorPrimerFLujo = await PortalColaboradorService.obtenerAprobadorPrimerFlujo();
			setAprobadorPrimerFlujo(aprobadorPrimerFLujo);
		};
		cargarDatos();
	}, []);
	return { aprobadorPrimerFlujo };
};

export default useObtenerAprobadorPrimerNivel;
